module.exports = __webpack_public_path__ + "img/companyIntro38.fc06fad5.png";